export default "__VITE_ASSET__CAo0lxW8__"